import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bba-entrance',
  templateUrl: './bba-entrance.component.html',
  styleUrls: ['./bba-entrance.component.scss']
})
export class BbaEntranceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
